module.exports = __webpack_public_path__ + "img/selecta_loader.ed3f58ae.svg";